import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import jobPartiesMixin from './jobPartiesMixin'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [jobPartiesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
    }),
    hasReviewed() {
      if (this.application?.isCompleted) {
        return this.isEmployer ? this.application.customerLeftReview : this.application.freelancerLeftReview
      }
      return false
    },
    hasLeaveReview() {
      if (!this.application?.isCompleted) return false

      return this.isEmployer ? !this.application.customerLeftReview : !this.application.freelancerLeftReview
    },
  },
  methods: {
    ...mapActions({
      openModal: 'ui/openModal',
    }),
    ...mapMutations({
      updateApplication: 'jobChat/updateApplication',
    }),
    leaveReview() {
      this.openModal({
        component: 'lx-lazy-modal',
        props: {
          factory: import(/* webpackChunkName: "job-modals" */ '@/modals/LeaveFeedback/LeaveFeedback.vue'),
          title: 'Leave a review',
          props: {
            fromFreelancer: this.isFreelancer,
            jobId: this.application.job.id,
            name: this.application.job.name,
            profile: this.isFreelancer ? this.application.customer : this.application.freelancer,
            onSuccess: this.onSuccessLeavingReview,
          },
        },
      })
    },
    onSuccessLeavingReview() {
      if (this.isEmployer) {
        this.updateApplication({ id: this.application.id, customerLeftReview: true })
      } else {
        this.updateApplication({ id: this.application.id, freelancerLeftReview: true })
      }
    },
  },
})
